var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.to}},[_vm._t("default"),_vm._v(" "),(_vm.active)?_c('span',{staticClass:"fa",class:_vm.indicatorClass}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }